import {
  COMMON_EXPORT_CSV,
  COMMON_GET_FILE,
  COMMON_MODAL_CLOSE,
  COMMON_MODAL_OPEN,
  COMMON_NOTIFICATION_CLOSE,
  COMMON_NOTIFICATION_OPEN,
  COMMON_EMAIL_NOTIFICATION_POST,
  COMMON_EMAIL_NOTIFICATION_DISMISS,
  COMMON_EMAIL_NOTIFICATION_FAIL,
  COMMON_EMAIL_NOTIFICATION_SUCCESS,
  COMMON_GET_WP_CONTENT_ATTEMPT,
  COMMON_GET_WP_CONTENT_SUCCESS,
  COMMON_GET_WP_CONTENT_FAILURE,
  COMMON_SCROLL_TO_ELEMENT,
  COMMON_ALERT_OPEN,
  COMMON_ALERT_CLOSE,
  COMMON_EXPORT_POSTINGS_UPDATES_CSV
} from './actionTypes'

export const exportCSV = ({ data, filename, headers }) => ({
  type: COMMON_EXPORT_CSV,
  meta: {},
  payload: {
    data,
    filename,
    headers
  }
})

export const exportPostingsUpdatesCSV = ({ data, filename, headers, companyId, params }) => ({
  type: COMMON_EXPORT_POSTINGS_UPDATES_CSV,
  meta: {},
  payload: {
    data,
    filename,
    headers,
    companyId,
    params
  }
})

export const getFile = (id, type, name) => ({
  type: COMMON_GET_FILE,
  meta: {},
  payload: {
    id,
    type,
    name
  }
})

export const modalClose = () => ({
  type: COMMON_MODAL_CLOSE,
  meta: {},
  payload: {}
})

export const modalOpen = options => ({
  type: COMMON_MODAL_OPEN,
  meta: {},
  payload: options
})

export const alertClose = () => ({
  type: COMMON_ALERT_CLOSE,
  meta: {},
  payload: {}
})

export const alertOpen = options => ({
  type: COMMON_ALERT_OPEN,
  meta: {},
  payload: options
})

export const notificationClose = () => ({
  type: COMMON_NOTIFICATION_CLOSE,
  meta: {},
  payload: {}
})

export const emailNotificationPost = data => ({
  type: COMMON_EMAIL_NOTIFICATION_POST,
  meta: {},
  payload: data
})

export const emailNotificationDismiss = data => ({
  type: COMMON_EMAIL_NOTIFICATION_DISMISS,
  meta: {},
  payload: data
})

export const emailNotificationSuccess = data => ({
  type: COMMON_EMAIL_NOTIFICATION_SUCCESS,
  meta: {},
  payload: data
})

export const emailNotificationFail = data => ({
  type: COMMON_EMAIL_NOTIFICATION_FAIL,
  meta: {},
  payload: {
    data
  }
})

export const notificationOpen = options => ({
  type: COMMON_NOTIFICATION_OPEN,
  meta: {},
  payload: options
})

export const wpContent = () => ({
  type: COMMON_GET_WP_CONTENT_ATTEMPT,
  meta: {},
  payload: {}
})

export const getContentSuccess = data => ({
  type: COMMON_GET_WP_CONTENT_SUCCESS,
  meta: {},
  payload: data
})

export const getContentFailure = data => ({
  type: COMMON_GET_WP_CONTENT_FAILURE,
  meta: {},
  payload: {
    data
  }
})

export const scrollToElement = element => ({
  type: COMMON_SCROLL_TO_ELEMENT,
  meta: {},
  payload: {
    element
  }
})

export default {}
